import { IRootState } from '../../../store'
import { IPcsInformationOptionsState } from '../store/options.types'

export const getPcsInformationOptionsSelector = (state: IRootState): IPcsInformationOptionsState =>
  state.options.pcsInformationOption
